import React from 'react';

class RatingScale extends React.Component {

    constructor(props) {
        super(props);
        this.state = { selectedRating: -1 };
    }

    componentWillUnmount() {
        if (this.timeoutId)
            clearTimeout(this.timeoutId);
    }

    onHoverIn = (selectedRating) => {
        this.setState({ selectedRating });
    }

    onHoverOut = () => {
        this.setState({ selectedRating: -1 });
    }

    onClick = (selectedRating) => {
        if (this.state.selectedRating !== selectedRating)
            this.setState({ selectedRating });
        const { onRatingClick } = this.props;
        if (onRatingClick)
            this.timeoutId = setTimeout(onRatingClick, 500, selectedRating);
    }

    render() {
        const { selectedRating } = this.state;
        const { backgroundColors } = this.props;
        return (<div className="rating-scale">
            {backgroundColors && backgroundColors.length > 0 && backgroundColors.map((background, index) => {
                const unitRating = index + 1;
                const isSelected = unitRating <= selectedRating;
                const isHovered = unitRating === selectedRating;
                return (<div className={`rating-unit${isSelected ? " no-border" : ""}`}
                    style={isSelected ? { backgroundColor: background } : undefined}
                    onMouseEnter={() => { this.onHoverIn(index + 1); }}
                    onMouseLeave={this.onHoverOut}
                    onClick={() => { this.onClick(index + 1); }}
                    key={index}
                >
                    {isHovered ? <div className="marker top" /> : null}
                    <div>{index + 1}</div>
                    {isHovered ? <div className="marker bottom" /> : null}
                </div>);
            })}
        </div>);
    }
}

export default RatingScale;